import { render, staticRenderFns } from "./page5Mobile.vue?vue&type=template&id=2a2e7a9b&scoped=true&"
import script from "./page5Mobile.vue?vue&type=script&lang=js&"
export * from "./page5Mobile.vue?vue&type=script&lang=js&"
import style0 from "./page5Mobile.vue?vue&type=style&index=0&id=2a2e7a9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e7a9b",
  null
  
)

export default component.exports